import React from 'react';
import { Link } from 'react-router-dom';

const BreadCrumb = ({active_page,prev_sub_page,sub_page}) => {
    return (
        <>
            <section class="breadcrumb-section">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                        {prev_sub_page &&
                            <li class="breadcrumb-item"><Link to={prev_sub_page.link}>{prev_sub_page.text}</Link></li>
                        }
                        {sub_page &&
                            <li class="breadcrumb-item"><Link to={sub_page.link}>{sub_page.text}</Link></li>
                        }
                        <li class="breadcrumb-item active" aria-current="page">{active_page}</li>
                    </ol>
                </nav>
            </section>
        </>
    );
};

export default BreadCrumb;
